<template>
  <div class="pausa-app-section">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a
            href="https://play.google.com/store/apps/details?id=com.xubio.android&hl=es"
            target="_blank"
          >
            <h4 class="client">Xubio APP</h4>
          </a>
          <h1 class="title">
            {{ $t("xubioApp.title") }}
          </h1>
          <p class="date">
            {{ $t("xubioApp.duration.title") }}
            {{ $t("xubioApp.duration.date") }}
          </p>
          <p class="role">
            {{ $t("xubioApp.position.title") }}
            {{ $t("xubioApp.position.role") }}
          </p>
          <p class="description">
            {{ $t("xubioApp.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("xubioApp.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("xubioApp.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("xubioApp.bullet3") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("xubioApp.bullet4") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img class="app-image" src="@/assets/xubio-app.png" alt="" />
          <div class="store-icons is-hidden-mobile">
            <a
              href="https://play.google.com/store/apps/details?id=com.xubio.android&hl=es"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="@/assets/playstore.png" alt="" class="demo" />
            </a>
            <a
              href="https://apps.apple.com/us/app/xubio/id1410352503"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="@/assets/image10.png" alt="" class="demo" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XubioMobileApp",
  components: {},
};
</script>
<style lang="scss" scoped>
div.pausa-app-section {
  background-color: #0ebce6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 3rem;

  div.columns {
    height: 100%;
  }

  @media (min-width: 600px) {
    height: 100vh;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: bold;
      color: gray;
      //margin-bottom: 0.5rem;
    }

    h1.title {
      font-family: "Raleway";
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #000;
      font-size: 1.2rem;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      li {
        text-align: left;
        margin: 0.5rem 0;
        // font-weight: 500;
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    img.app-image {
      height: auto;
      max-width: 80%;

      @media (min-width: 600px) {
        max-height: 68vh;
        max-width: 28rem;
      }
    }

    div.store-icons {
      background: transparent;
      display: flex;
      gap: 1rem;
      justify-content: center;
      margin-top: 1.25rem;

      img {
        height: 2.5rem;
        margin: 0;
      }
    }

    @media (max-width: 700px) {
      img.app-image {
        max-width: 80%;
      }
    }
  }
}
</style>
